// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_Ph5","cls2":"utils-cls2_XCc utils-cls1_Ph5"};